import { render, staticRenderFns } from "./reset-user.vue?vue&type=template&id=ec1005bc"
import script from "./reset-user.vue?vue&type=script&lang=ts"
export * from "./reset-user.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports